/* eslint-disable compat/compat */
import { UNAVAILABLE } from './constants';
/**
 * Get user agent if it is available
 */
export function getUserAgent() {
    return typeof navigator === 'object' ? navigator.userAgent : UNAVAILABLE;
}
/**
 * Get information about the system's connections ('wifi', 'cellular', etc)
 * More Information: https://developer.mozilla.org/en-US/docs/Web/API/Network_Information_API
 * */
export function getConnectionType() {
    // @ts-expect-error `navigator.connection` property is not defined in lib.dom.d.ts but might exist
    var connection = typeof navigator === 'object' && (navigator.connection || navigator.mozConnection || navigator.webkitConnection);
    return connection ? connection.effectiveType : UNAVAILABLE;
}
/**
 * Get the current page URL
 */
export function getUrl() {
    return location.href; // equivalent to `document.URL`
}
/**
 * Get the current page URL without origin. i.e, path, query params and fragment, without schema, hostname and port
 */
export function getRoute() {
    return location.pathname + location.search + location.hash;
}
export var userAgent = getUserAgent();
export var languageVersion = 'jsrum-' + '0.7.1';
